// import React, { useState, useRef, useEffect } from "react";
// import styles from "./FAQ.module.css";
// import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

// const FAQ = ({ faqs = [] }) => {
//   const [isExpanded, setIsExpanded] = useState({
//     state: false,
//     index: null,
//   });

//   const ref = useRef({});

//   const contentRefsLeft = faqs.slice(faqs.length / 2).map(() => useRef(null));
//   const contentRefsRight = faqs.slice(0, faqs.length / 2).map(() => useRef(null));

//   useEffect(() => {
//     // Dynamically set the height of each content based on its actual height
//     contentRefsLeft.forEach((ref, index) => {
//       if (ref.current) {
//         ref.current.style.height =
//           isExpanded.index === index + faqs.length / 2 && isExpanded.state
//             ? `${ref.current.scrollHeight}px`
//             : "0px";
//       }
//     });

//     contentRefsRight.forEach((ref, index) => {
//       if (ref.current) {
//         ref.current.style.height =
//           isExpanded.index === index && isExpanded.state
//             ? `${ref.current.scrollHeight}px`
//             : "0px";
//       }
//     });
//   }, [isExpanded, faqs]);

//   return (
//     <div className="py-12">
//       <h4 className="text-2xl sm:text-4xl font-semibold capitalize text-center">
//         Frequently Asked Questions
//       </h4>
//       <div className="w-full mt-6 sm:mt-10 flex flex-col justify-center md:flex-row items-start flex-wrap">
//         <div className="w-full md:w-[48%] md:mr-2">
//           {faqs?.slice(faqs.length / 2).map((faq, i) => (
//             <div
//               key={i}
//               onClick={() => {
//                 setIsExpanded((prev) => ({
//                   state: prev.index === i + faqs.length / 2 ? !prev.state : true,
//                   index: i + faqs.length / 2,
//                 }));
//               }}
//               className={`faq-wrapper ${
//                 isExpanded.index === i + faqs.length / 2 && isExpanded.state && styles.fadeIn
//               } w-full mb-4 border rounded-lg px-4 py-3 cursor-pointer`}
//             >
//               <div className="flex flex-row items-center justify-between">
//                 <h2 className="text-base sm:text-lg font-semibold">
//                   {faq.title}
//                 </h2>
//                 <span className="ml-4 cursor-pointer hover:opacity-90">
//                   {isExpanded.index === i + faqs.length / 2 && isExpanded.state ? (
//                     <MdKeyboardArrowUp className="text-3xl" />
//                   ) : (
//                     <MdKeyboardArrowDown className="text-3xl" />
//                   )}
//                 </span>
//               </div>
//               <div
//                 ref={contentRefsLeft[i]}
//                 className={`text-sm md:text-base mt-2 overflow-hidden transition-height duration-300 ease-in-out`}
//               >
//                 {faq.desc}
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="w-full md:w-[48%] md:ml-2">
//           {faqs?.slice(0, faqs.length / 2).map((faq, i) => (
//             <div
//               key={i}
//               onClick={() => {
//                 setIsExpanded((prev) => ({
//                   state: prev.index === i ? !prev.state : true,
//                   index: i,
//                 }));
//               }}
//               className={`faq-wrapper ${
//                 isExpanded.index === i && isExpanded.state && styles.fadeIn
//               } w-full mb-4 border rounded-lg px-4 py-3 cursor-pointer`}
//             >
//               <div className="flex flex-row justify-between">
//                 <h2 className="text-base sm:text-lg font-semibold">
//                   {faq.title}
//                 </h2>
//                 <span className="ml-4  hover:opacity-90">
//                   {isExpanded.index === i && isExpanded.state ? (
//                     <MdKeyboardArrowUp className="text-3xl" />
//                   ) : (
//                     <MdKeyboardArrowDown className="text-3xl" />
//                   )}
//                 </span>
//               </div>
//               <div
//                 ref={contentRefsRight[i]}
//                 className={`text-sm md:text-base mt-2 overflow-hidden transition-height duration-300 ease-in-out`}
//               >
//                 {faq.desc}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FAQ;


import React, { useState } from "react";
// import "./index.css";
import styles from "./FAQ.module.css";

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const FAQ = ({ faqs = [] }) => {
  const [isExpanded, setIsExpanded] = useState({
    state: false,
    index: null,
  });

  return (
    <div className="py-12">
      <h4 className="text-2xl sm:text-4xl font-semibold capitalize text-center">
        Frequently Asked Questions
      </h4>
      <div className="w-full mt-6 sm:mt-10 flex flex-col md:flex-row items-start flex-wrap">
        <div className="w-full md:w-[48%] md:mr-2">
          {faqs?.slice(faqs.length / 2).map((faq, i) => (
            <div
              key={i}
              onClick={() => {
                setIsExpanded((prev) => ({
                  state: prev.index === faq.id ? !prev.state : true,
                  index: faq.id,
                }));
              }}
              className={`${
                isExpanded.index === faq.id && isExpanded.state && "fadeIn"
              } w-full mb-4 border rounded-lg p-4 cursor-pointer`}
            >
              <div className="flex flex-row items-center justify-between">
                <h2 className="text-base sm:text-lg font-semibold">
                  {faq.title}
                </h2>
                <span className="ml-4 cursor-pointer hover:opacity-90">
                  {isExpanded.index === faq.id && isExpanded.state ? (
                    <MdKeyboardArrowUp className="text-3xl" />
                  ) : (
                    <MdKeyboardArrowDown className="text-3xl" />
                  )}
                </span>
              </div>
              {isExpanded.index === faq.id && isExpanded.state && (
                <p className={`text-sm md:text-base mt-2`}>{faq.desc}</p>
              )}
            </div>
          ))}
        </div>
        <div className="w-full md:w-[48%] md:ml-2">
          {faqs?.slice(0, faqs.length / 2).map((faq, i) => (
            <div
              key={i}
              onClick={() => {
                setIsExpanded((prev) => ({
                  state: prev.index === faq.id ? !prev.state : true,
                  index: faq.id,
                }));
              }}
              className={`faq-wrapper ${
                isExpanded.index === faq.id && isExpanded.state && "fadeIn"
              } w-full mb-4 border rounded-lg p-4 cursor-pointer`}
            >
              <div className="flex flex-row justify-between">
                <h2 className="text-base sm:text-lg font-semibold">
                  {faq.title}
                </h2>
                <span className="ml-4  hover:opacity-90">
                  {isExpanded.index === faq.id && isExpanded.state ? (
                    <MdKeyboardArrowUp className="text-3xl" />
                  ) : (
                    <MdKeyboardArrowDown className="text-3xl" />
                  )}
                </span>
              </div>
              {isExpanded.index === faq.id && isExpanded.state && (
                <p className={`text-sm md:text-base mt-2`}>{faq.desc}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;